import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import "./staticSite/assets/css/bootstrap.min.css";
// import "./staticSite/assets/css/now-ui-kit.css";
// import "./staticSite/assets/demo/demo.css";
// import "./assets/css/main.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
